import React from "react";
import { useMatch } from "react-router-dom";
import RecordFormResponsesPage from "../tournament-reporting/tournament-record-form-responses";

const TournamentSponsorFormResponses = () => {
  const match = useMatch("/:tournamentID/sponsors/:sponsorID/form-responses");

  return (
    <RecordFormResponsesPage
      key={`sponsor-${match?.params?.sponsorID}`}
      tournamentID={match?.params?.tournamentID}
      recordType="sponsors"
      recordKey={match?.params?.sponsorID}
      emptyEntity="sponsor"
    />
  );
};

export default TournamentSponsorFormResponses;
